// 列ID・パネルtypeの正規化をまとめる。加工指示/品番マスタで同一実装を使うための共有モジュール。
// 本文は Kakousiji.js の実装をそのまま移設したもの。
export function createColumnIdUtil(deps) {
    const {
        isEmpty,
        DicVal
    } = deps;

    function normalizeTypeKey(key) {
        if (isEmpty(key)) return "";
        const s = String(key).trim().toLowerCase();
        if (s === "20" || s === "130" || s === "jutyusu") return "130";
        if (s === "21" || s === "131" || s === "nouhinyotei") return "131";
        return s;
    }
    function canonicalPanelType(type) {
        if (isEmpty(type)) return "";
        const s = String(type).trim();
        const low = s.toLowerCase();
        if (low === "20" || low === "130" || low === "jutyusu") return "130";
        if (low === "21" || low === "131" || low === "nouhinyotei") return "131";
        return s;
    }
    function demandTypeKeyByPanel(panelInfo) {
        if (isEmpty(panelInfo)) return "";
        const typeKey = normalizeTypeKey(DicVal(panelInfo, "type", ""));
        if (typeKey === "130" || typeKey === "131") return typeKey;
        const pid = String(DicVal(panelInfo, "id", "")).trim().toLowerCase();
        if (pid === "20") return "130";
        if (pid === "21") return "131";
        return "";
    }
    function normalizeLabelKey(label) {
        if (isEmpty(label)) return "";
        return String(label).replace(/\s+/g, "").replace(/[　]/g, "").trim();
    }
    function normalizeColumnIdUpper(columnid) {
        return String(columnid ?? "").trim().toUpperCase();
    }
    function normalizeColumnIdSuffix(columnid) {
        const raw = String(columnid ?? "").toLowerCase();
        if (raw === "") return "";
        let cid = raw;
        const idx = cid.indexOf("_");
        if (idx !== -1) cid = cid.substring(idx + 1);
        if (cid.startsWith("ssdgm_")) cid = cid.substring(6);
        if (cid.startsWith("ssd_")) cid = cid.substring(4);
        return cid.replace(/[^a-z0-9]/g, "");
    }

    return {
        normalizeTypeKey,
        canonicalPanelType,
        demandTypeKeyByPanel,
        normalizeLabelKey,
        normalizeColumnIdUpper,
        normalizeColumnIdSuffix
    };
}
